/**
 * @module Utils
 *
 */

type RouteOpts = {
  replace?: boolean;
  reload?: boolean;
};

export function routeNative(destination: string, options: RouteOpts) {
  options = options != null ? options : {};

  if (options.replace && window.location.replace != null) {
    window.location.replace(destination);
  } else if (!options.reload && window.location.assign != null) {
    window.location.assign(destination);
  } else {
    window.location = ((destination as any) as Location);
  }
}
